export enum SIGNATURE {
  ATTACHMENT = 'Attachment',
  DHFILE = 'DHFile',
}

export const FROALA_DEFAULT_ALLOWED_TAGS = [
  'accept',
  'accept-charset',
  'accesskey',
  'action',
  'align',
  'allowfullscreen',
  'allowtransparency',
  'alt',
  'async',
  'autocomplete',
  'autofocus',
  'autoplay',
  'autosave',
  'background',
  'bgcolor',
  'border',
  'charset',
  'cellpadding',
  'cellspacing',
  'checked',
  'cite',
  'class',
  'color',
  'cols',
  'colspan',
  'content',
  'contenteditable',
  'contextmenu',
  'controls',
  'coords',
  'data',
  'data-.*',
  'datetime',
  'default',
  'defer',
  'dir',
  'dirname',
  'disabled',
  'download',
  'draggable',
  'dropzone',
  'enctype',
  'for',
  'form',
  'formaction',
  'frameborder',
  'headers',
  'height',
  'hidden',
  'high',
  'href',
  'hreflang',
  'http-equiv',
  'icon',
  'id',
  'ismap',
  'itemprop',
  'keytype',
  'kind',
  'label',
  'lang',
  'language',
  'list',
  'loop',
  'low',
  'max',
  'maxlength',
  'media',
  'method',
  'min',
  'mozallowfullscreen',
  'multiple',
  'muted',
  'name',
  'novalidate',
  'open',
  'optimum',
  'pattern',
  'ping',
  'placeholder',
  'playsinline',
  'poster',
  'preload',
  'pubdate',
  'radiogroup',
  'readonly',
  'rel',
  'required',
  'reversed',
  'rows',
  'rowspan',
  'sandbox',
  'scope',
  'scoped',
  'scrolling',
  'seamless',
  'selected',
  'shape',
  'size',
  'sizes',
  'span',
  'src',
  'srcdoc',
  'srclang',
  'srcset',
  'start',
  'step',
  'summary',
  'spellcheck',
  'style',
  'tabindex',
  'target',
  'title',
  'type',
  'translate',
  'usemap',
  'value',
  'valign',
  'webkitallowfullscreen',
  'width',
  'wrap',
];
